<template>
  <div style="margin-top: 30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="120px">
      <el-form-item label="开户银行" prop="bankNo" style="margin-right: 15px">
        <el-select
          v-model="form.bankNo"
          placeholder="请选择"
          clearable
          filterable
          @change="setBankName"
        >
          <el-option
            v-for="item in bankList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="开户网点"
        prop="bankBranche"
        style="margin-right: 15px"
      >
        <el-input
          v-model.trim="form.bankBranche"
          placeholder="请选择开户网点"
          clearable
          ref="inputRef"
          @clear="clearInput()"
          @focus="designatedBank()"
          @input="designatedBank()"
        />
      </el-form-item>
      <el-form-item
        label="开户行省份"
        prop="provinceCode"
        style="margin-right: 15px"
      >
        <el-select
          v-model="form.provinceCode"
          placeholder="请选择"
          clearable
          filterable
          @change="getCityList"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.provinceCode"
            :label="item.provinceName"
            :value="item.provinceCode"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="开户行城市"
        prop="cityCode"
        style="margin-right: 15px"
      >
        <el-select v-model="form.cityCode" placeholder="请选择" clearable>
          <el-option
            v-for="item in cityList"
            :key="item.cityCode"
            :label="item.cityName"
            :value="item.cityCode"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="funcSubmit">确 认</el-button>
    </div>
    <BankBranchList ref="BankBranchRef" @event="setBankBranch" />
  </div>
</template>
<script>
import request from "@/utils/request";
import BankBranchList from "../../../../bankCard/components/BankBranchList";
import { getListDict } from "@/api/commonApi";
export default {
  name: "bankInquiry",
  components: { BankBranchList },
  props: ["bankName", "bankNo", "bankAssociationNumber", "bankBranche"],
  data() {
    return {
      provinceList: [],
      cityList: [],
      bankList: [],
      form: {
        bankName: "",
        bankNo: "",
        bankBranche: "",
        provinceCode: "",
        cityCode: ""
      },
      rules: {
        bankNo: [
          { required: true, message: "请选择开户银行", trigger: "blur" }
        ],
        bankBranche: [
          { required: true, message: "请选择开户网点", trigger: "blur" }
        ]
      }
    };
  },
  created() {},
  methods: {
    // 获取页面信息
    getInfo() {
      this.getProvinceList();
      this.selectDict();
      this.form.bankNo = this.bankNo;
      this.form.bankName = this.bankName;
      this.form.bankAssociationNumber = this.bankAssociationNumber;
      this.form.bankBranche = this.bankBranche;
    },

    clearInput() {
      this.form.bankBranche = "";
      this.form.bankAssociationNumber = "";
    },

    setBankBranch(data) {
      this.$refs.inputRef.focus();
      this.form.bankBranche = data.bankName;
      this.form.bankAssociationNumber = data.bankNo;
      this.$refs.inputRef.blur();
    },
    // 获取中台银行网点、联行号
    designatedBank() {
      if (!this.form.bankNo) {
        return this.$message.warning("请选择开户银行");
      }
      this.$refs.BankBranchRef.show(this.form.bankNo);
    },
    // 查询数据字典
    selectDict() {
      // 获取数据字典： 银行
      getListDict({ types: "bank,cardType" }).then(response => {
        this.bankList = response.data.filter(item => item.type === "bank")[0][
          "dictList"
        ];
        this.bankCardTypeList = response.data.filter(
          item => item.type === "cardType"
        )[0]["dictList"];
      });
    },
    setBankName() {
      console.log("设置银行信息====", this.form.bankNo);
      // this.form.bankName = this.form.bankObject.name
      // this.form.bankNo = this.form.bankObject.branchCode

      this.form.bankName = this.bankList.find(
        option => option.code === this.form.bankNo
      ).name;
      this.form.bankBranche = null;
      // console.log('Label:', selectedLabel);
      // console.log('Value:', this.form.bankName);
    },
    // 获取省列表
    getProvinceList() {
      request({ url: "/ntocc-basic-api/areaProvince", method: "get" }).then(
        response => {
          this.provinceList = response.data.records;
        }
      );
    },
    // 获取市列表
    getCityList(data) {
      this.cityList = [];
      this.form.city = "";
      this.form.cityCode = "";
      request({
        url: "/ntocc-basic-api/areaCity",
        method: "get",
        params: { provinceCode: this.form.provinceCode }
      }).then(response => {
        this.cityList = response.data.records;
      });
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.$emit("quirySubmit", this.form);
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  display: flex;
  justify-content: center;
  // margin:15px 0 15px 0;
  // width: 175px;
  // float: right;
}
</style>
